<template>
  <div class="p-back-button flex">
    <template v-if="isSquare">
      <UButton
        icon="i-heroicons-chevron-left"
        color="neutral"
        variant="ghost"
        size="md"
        square
        :aria-label="t('menu.back_button.aria')"
        @click="onClick"
      />
    </template>
    <template v-else>
      <div class="p-back-button__mobile flex lg:hidden">
        <UButton
          icon="i-heroicons-chevron-left"
          color="neutral"
          variant="ghost"
          size="md"
          :aria-label="t('menu.back_button.aria')"
          :label="t('menu.back_button.text')"
          @click="onClick"
        />
      </div>
      <div class="p-back-button__desktop hidden lg:flex">
        <UButton
          icon="i-heroicons-chevron-left"
          color="neutral"
          variant="solid"
          size="md"
          :aria-label="t('menu.back_button.aria')"
          :label="t('menu.back_button.text')"
          @click="onClick"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useMenuReferrer } from '../composables/useMenuReferrer'
const { referrerValid } = useMenuReferrer()
const router = useRouter()

const onClick = () => {
  if (referrerValid() || router.options.history.state.back) {
    history.back()
  } else {
    window.location.assign('/')
  }
}

interface PropsType {
  isSquare?: boolean
}

withDefaults(defineProps<PropsType>(), {
  isSquare: true,
})
</script>
